module.exports = __webpack_public_path__ + "static/media/TRONY.07e65bc8.svg";